
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";
import { getService } from "../../app/api";
import { Link, useNavigate } from "react-router-dom";

const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 1240,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 940,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
    ],
};

const ServiceSlider = ({ dark = false }: { dark?: boolean }) => {
    const { t } = useTranslation();
    const [Data, setData] = useState([]);

    useEffect(() => {
        try {
            getService().then((res) => {
                if (res) {
                    setData(res.data.results);
                }
            });
        } catch (err) {
        }
    }, []);

    const ServiceCard = ({ service }: { service: any }) => (
        <div className={`group h-full flex flex-col ${dark ? 'rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm overflow-hidden hover:bg-white/[0.08] hover:border-white/20 transition-all duration-300' : 'card-hover'}`}>
            <Link to={`/service/${service.id}`}>
                <div className={`relative w-full overflow-hidden ${dark ? '' : 'rounded-t-2xl'}`}>
                    <img
                        loading="lazy"
                        className="aspect-[16/10] w-full object-cover group-hover:scale-105 transition-transform duration-500"
                        src={service.thumb}
                        alt={service.title}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-primary-600/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
            </Link>
            <div className="p-6 flex flex-col flex-1">
                <h3 className={`text-lg font-bold leading-7 tracking-tight line-clamp-2 mb-4 transition-colors flex-1 ${dark ? 'text-white group-hover:text-primary-300' : 'text-neutral-900 group-hover:text-primary-600'}`}>
                    {service.title}
                </h3>
                <Link to={`/service/${service.id}`}>
                    <button className={dark ? "inline-flex items-center gap-1.5 text-sm font-semibold text-primary-400 hover:text-primary-300 transition-colors" : "btn-primary text-sm"}>
                        {t('service.more')}
                        {dark && (
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                        )}
                    </button>
                </Link>
            </div>
        </div>
    );

    return (
        <div className={`py-16 sm:py-20 ${dark ? '' : 'bg-white'}`}>
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-3xl text-center mb-12">
                    <h2 className={`section-header text-3xl sm:text-4xl mb-4 ${dark ? 'text-white' : ''}`}>
                        {dark ? t('service.title') : <span className="gradient-text">{t('service.title')}</span>}
                    </h2>
                    <p className={`mt-6 text-lg leading-8 ${dark ? 'text-slate-400' : 'text-neutral-500'}`}>
                        {t('service.description')}
                    </p>
                </div>
                <div>
                    <div>
                        {Data.length <= 3 ?
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                                {Data.map((service: any) => (
                                    <ServiceCard key={service.title} service={service} />
                                ))}
                            </div> :
                            <Slider {...settings}>
                                {Data.map((service: any) => (
                                    <div key={service.title} className="px-3 h-full">
                                        <ServiceCard service={service} />
                                    </div>
                                ))}
                            </Slider>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceSlider;
